import { Box, Grid, IconButton, Typography } from '@mui/material';
import { useMemo, useState } from 'react';
import { BsEye } from 'react-icons/bs';
import { useNavigate } from 'react-router-dom';
import { Cell } from 'react-table';
import {
  WsChip,
  WsChipVariants,
  WsColors,
  WsDataTable,
  WsIconJobOutline,
  WsIconPersons,
  WsTypoColors,
  WsTypography,
  WsListingLoader,
  timeSince,
  WsPagination,
} from 'wisestep-base';

import NoDataFoundCard from '../../../../../components/noDataFoundCard';
import useMassMailingLogSearch from '../../../hooks/useMassMailingLogSearch';
import { massMailingLogSearchDefaultQuery } from '../../../utils/vendorsHelper';

const BroadCastTable = () => {
  const [loader, setLoader] = useState<boolean>(false);
  const [query, setQuery] = useState(massMailingLogSearchDefaultQuery);
  query.massMailingGroupId = '';
  query.firstRecordsOnly = true;
  const [vendorList, totalCount] = useMassMailingLogSearch(query, setLoader);
  const navigate = useNavigate();
  const [pageNumber, setPageNumber] = useState<number>(1);

  const pageChange = (event, value) => {
    const updatedQuery = { ...query };
    updatedQuery.page = value;
    setQuery(updatedQuery);
    setPageNumber(value + 1);
  };
  const columns = [
    {
      Header: 'BroadCast Type',
      accessor: 'broadCastType',
      Cell: (cell: Cell) => (
        <WsChip
          icon={cell.value === 'JobBroadcasting' ? <WsIconJobOutline /> : <WsIconPersons />}
          value={cell.value === 'JobBroadcasting' ? 'Jobs' : 'Candidates'}
          variant={
            cell.value === 'JobBroadcasting' ? WsChipVariants.SECONDARY : WsChipVariants.TERTIARY
          }
        />
      ),
    },
    {
      Header: 'Subject',
      accessor: 'subject',
    },

    {
      Header: 'Sent by',
      accessor: 'sentBy',
      Cell: (cell: Cell) => <WsTypography color={WsTypoColors.BLACK}>{cell.value}</WsTypography>,
    },
    {
      Header: 'Sent on',
      accessor: 'sentOn',
      Cell: (cell: Cell) => (
        <Box display={'flex'} justifyContent={'space-between'}>
          <Typography color={WsColors.TertiaryShades800} fontWeight={'bold'} fontSize={'14px'}>
            {cell.value}
          </Typography>
        </Box>
      ),
    },
    {
      Header: 'Deatils',
      accessor: 'details',
      Cell: (cell: Cell) => (
        <IconButton onClick={() => navigate(`/vendors/broadcast-history/${cell.value}`)}>
          <BsEye />
        </IconButton>
      ),
    },
  ];

  const DATA = useMemo(
    () =>
      vendorList?.map((vendor) => ({
        vendorList: 'jobs',
        subject: vendor.subject,
        contentType: vendor.MassMailType,
        sentBy: vendor.createdBy,
        sentOn: timeSince(String(vendor.createdOn)),
        details: vendor.massMailingGroupId,
      })),
    [vendorList]
  );

  return (
    <Box>
      {vendorList?.length > 0 && !loader ? (
        <>
          <Grid xs={12} item pb={1}>
            <WsPagination
              count={Math.ceil(totalCount / 50)}
              onChange={pageChange}
              itemsPerPage={50}
              pageNumber={query.page}
              defaultPage={pageNumber}
              isPageCount={true}
              type="Vendors"
              totalCount={totalCount}
            />
          </Grid>
          <WsDataTable
            columns={columns}
            data={DATA || []}
            totalDataItems={totalCount}
            boldItems={['vendorList', 'subject']}
            pageable={false}
          />
        </>
      ) : loader ? (
        <WsListingLoader />
      ) : (
        <NoDataFoundCard text="No Vendors Found" />
      )}
      {vendorList?.length > 0 && (
        <Grid xs={12} item py={1}>
          <WsPagination
            count={Math.ceil(totalCount / 50)}
            onChange={pageChange}
            itemsPerPage={50}
            pageNumber={query.page}
            defaultPage={pageNumber}
            isPageCount={true}
            type="Vendors"
            totalCount={totalCount}
          />
        </Grid>
      )}
    </Box>
  );
};

export default BroadCastTable;
